export const QUESTION_TYPES = {
  QUESTIONS: "questions",
  MY_ANSWER: "my-answers"
};
